import React from 'react';

// Logo URLs with expanded shapes (no font dependency)
const LOGO_URL = "https://customer-assets.emergentagent.com/job_streamfinder-61/artifacts/35juqa1v_NLS%20SITE%20LOGO.svg";
const LOGO_PLUS_URL = "https://customer-assets.emergentagent.com/job_streamfinder-61/artifacts/w6gdm9gr_NLS%2B%20SITE%20LOGO.svg";

export const Logo = ({ className = "h-10 w-auto", variant = "default" }) => {
  const logoSrc = variant === "plus" ? LOGO_PLUS_URL : LOGO_URL;
  const altText = variant === "plus" ? "New Logical Sports+" : "New Logical Sports";

  return (
    <img 
      src={logoSrc}
      alt={altText}
      className={className}
    />
  );
};

export default Logo;
